import React, { useContext } from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UserContext } from '../../Context/UserContext';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 420,
  bgcolor: 'white',
  boxShadow: 24,
  outline: 'none',
};

function SelectBank({ open, handleClose }) {
  const { userDetails } = useContext(UserContext);
  const userData = userDetails || {};

  const accNo = userData.virtualAccountNumber || localStorage.getItem("virtualAccountNumber") || "";
  const accName = userData.virtualAccountName || localStorage.getItem("virtualAccountName") || "";

  const copyText = () => {
    if (!accNo) {
      toast.error("Account number not available.");
      return;
    }
    navigator.clipboard
      .writeText(accNo)
      .then(() => {
        toast.success("Account details copied to clipboard!", { autoClose: 1500 });
      })
      .catch((err) => {
        toast.error("Failed to copy account details.");
      });
  };

  return (
    <Modal
      aria-labelledby="bank-transfer-modal-title"
      aria-describedby="bank-transfer-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
        sx: { backgroundColor: 'rgba(0, 0, 0, 0.4)' }
      }}
    >
      <Fade in={open}>
        <Box sx={style} className="rounded-2xl p-6 relative">
          {/* Close Button */}
          <button
            onClick={handleClose}
            className="absolute top-4 right-4 w-8 h-8 rounded-full bg-[#1C1F2A] flex items-center justify-center text-white hover:bg-[#2C3142] transition-colors focus:outline-none"
            aria-label="Close"
          >
            <CloseIcon style={{ fontSize: "16px" }} />
          </button>

          <div className="pt-4">
            <div className="mx-auto w-20 h-20 rounded-full bg-[#F4FBF7] flex items-center justify-center mb-6">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 22H22" stroke="#00A85A" strokeWidth="2" strokeLinecap="round" />
                <path d="M12 2L2 7V10H22V7L12 2Z" fill="#00A85A" stroke="#00A85A" strokeWidth="2" strokeLinejoin="round" />
                <path d="M4 10V19" stroke="#00A85A" strokeWidth="2" strokeLinecap="round" />
                <path d="M8 10V19" stroke="#00A85A" strokeWidth="2" strokeLinecap="round" />
                <path d="M12 10V19" stroke="#00A85A" strokeWidth="2" strokeLinecap="round" />
                <path d="M16 10V19" stroke="#00A85A" strokeWidth="2" strokeLinecap="round" />
                <path d="M20 10V19" stroke="#00A85A" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </div>

     
            <h2 id="bank-transfer-modal-title" className="text-[#1A1A1B] text-xl font-bold text-center mb-2">
              Bank transfer
            </h2>
            <p id="bank-transfer-modal-description" className="text-[#808285] text-[16px] text-center mb-6 px-2 leading-[150%]">
              Send money to this account to fund your Zouse wallet.
            </p>

       
            <div className="border border-[#E6E6E7] rounded-xl p-5 mb-6 space-y-4 bg-white">
              <div className="flex justify-between items-center">
                <span className="text-[#808285] text-[14px]">Bank name</span>
                <span className="text-[#1A1A1B] font-bold text-[14px]">Paystack Titan</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-[#808285] text-[14px]">Account number</span>
                <span className="text-[#1A1A1B] font-bold text-[14px]">{accNo || "Not Available"}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-[#808285] text-[14px]">Account name</span>
                <span className="text-[#1A1A1B] font-bold text-[14px]">{accName || "Not Available"}</span>
              </div>
            </div>

     
            <button
              onClick={copyText}
              className="w-full bg-[#1C1F2A] hover:bg-[#2C3142] text-white font-bold py-3.5 px-4 rounded-xl flex items-center justify-center gap-2 transition-colors duration-200 focus:outline-none"
            >
              <span className="text-[15px]">Copy account number</span>
              <ContentCopyIcon style={{ fontSize: "16px", color: "white" }} />
            </button>
          </div>
        </Box>
      </Fade>
    </Modal>
  );
}

export default SelectBank;